import React, { ChangeEvent, useId, useState } from 'react';
import Image from 'next/image';

import {
  TextInputWrapper,
  InputLabel,
  Input,
  ErrorMessage,
  IconWrapper
} from './style';

import { BaseInputProps, TextInputWidth } from '../shared';

import icon from '@/images/error_icon.svg';

interface TextInputProps extends BaseInputProps {
  borderColor?: string;
  handleOnChange: (event: ChangeEvent<HTMLInputElement>, value: any) => void;
}

export function TextInput({
  value,
  type,
  label,
  placeholder,
  error,
  required,
  handleOnChange,
  disabled = false,
  width = TextInputWidth.FULL,
  borderColor = '#00C9A7',
  inputMode,
  pattern,
  maxLength
}: TextInputProps) {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const inputId = useId();

  return (
    <>
      <TextInputWrapper width={width} error={!!error} borderColor={borderColor}>
        <InputLabel htmlFor={inputId} floatLabel={!!value || isFocused}>
          {label}
          {required ? '*' : ''}
        </InputLabel>
        <Input
          id={inputId}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          floatLabel={!!value || isFocused}
          inputMode={inputMode}
          pattern={pattern}
          maxLength={maxLength || 320}
          min="0"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (handleOnChange) handleOnChange(e, e.target.value);
          }}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          aria-required={required}
          aria-invalid={!!error}
          data-testid={`input-${type}-${label}`}
        />
      </TextInputWrapper>
      <ErrorMessage
        data-testid={`input-${type}-${label}-error`}
        visible={!!error}
      >
        <IconWrapper>
          <Image src={icon} alt="error icon" />
        </IconWrapper>
        {error || ''}
      </ErrorMessage>
    </>
  );
}
